import React, { Component } from 'react';
import { Button, Card, Flex, Heading } from 'core/components';
import { observer } from 'mobx-react';
import MetricsExplorerResult from 'app/views/metrics/MetricsExplorerResult';
import MetricsExplorerButton from 'app/views/metrics/MetricsExplorerButton';
import styled from 'styled-components';

const NmsWrapper = styled(Flex)`
  .me-tools {
    padding: 0 16px;
    margin: 0;
  }
`;

@observer
class NmsToolResult extends Component {
  render() {
    const { tool, chartHeight, onCloseToolResult } = this.props;

    if (!tool || !tool.query_object) {
      return <Flex>Invalid tool data for NMS.</Flex>;
    }

    return (
      <Card className="tool-result-nms" display="flex" flexDirection="column" minHeight={chartHeight}>
        <Flex alignItems="center" justifyContent="space-between" p={2} pb={0}>
          <Heading level={5} m={0}>
            {tool.title}
          </Heading>
          <Flex alignItems="center" gap={1}>
            <MetricsExplorerButton openInNewWindow text="View in Metrics Explorer" query={tool.query_object} />
            <Button text="Close" small icon="cross" onClick={() => onCloseToolResult(tool)} color="muted" minimal />
          </Flex>
        </Flex>

        <NmsWrapper flexDirection="column" flex={1} overflow="hidden" position="relative">
          <MetricsExplorerResult
            query={tool.query_object}
            showLegend
            showTools
            isWidget
            hideTotalRow
            chartHeight={chartHeight}
          />
        </NmsWrapper>
      </Card>
    );
  }
}

export default NmsToolResult;
